import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Tailwind className helper used by every shadcn component.
 * Combines conditional class composition (clsx) with Tailwind class
 * deduplication (tailwind-merge) so component callers can override defaults
 * cleanly: `cn("bg-blue-500", isPrimary && "bg-brand-forest-900")`.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * True when `url` is a browser-loadable image source: an http(s), data,
 * or blob URL, or a root-relative path (`/…`, e.g. the local dev
 * `/blob-mock/…` shim served through the Vite proxy — see
 * server/src/routes/blob_mock.rs). Guards `<img src>` against `file://`
 * URLs — browsers refuse to load them from an http page ("Not allowed to
 * load local resource"), producing console errors + broken-image icons.
 * Real Azure SAS URLs (https) in prod pass through; callers fall back to
 * their placeholder branch when this returns false.
 */
export function isLoadableImageUrl(
  url: string | null | undefined,
): url is string {
  return !!url && /^(https?:|data:|blob:|\/)/i.test(url);
}
